import get from 'lodash.get';
import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import {
  changeOutputType,
  setPrintDestination,
  documentDownloadStarted,
  setRememberPrintSettings,
  closingPrintModal,
} from '../../../store/printing/print.actions';
import { printDocumentRequest } from '../../../store/shipstation-connect/ss-connect.actions';
import { GuidService } from 'ui-components/services/guid-service';
import { DocumentService } from '../../../services/document-service';
import { PrintModal } from './index';

const defaultDocumentType = 'end-of-day-form';

const mapStateToProps = (state) => {
  const pdf = Global.selectPrintPdfFilePath(state) || '';
  const printer = Global.selectPrintPrintDestination(state);
  const scanFormIds = Global.selectPrintEndOfDayScanFormIds(state);
  return {
    outputType: Global.selectPrintOutputType(state),
    documentToPrint: pdf,
    documentType: defaultDocumentType,
    scanFormIds,
    printer,
    savedPreferences: get(state, 'printSettings.v3Settings'),
    rememberPrintSettings: Global.selectPrintRemeberPrintSettings(state),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const {
    modalFrameworkMethods: { closeModal },
  } = props;

  const closePrintModal = () => {
    dispatch(closingPrintModal());
    closeModal();
  };

  return {
    modalFrameworkMethods: {
      ...props.modalFrameworkMethods,
      closeModal: closePrintModal,
    },
    onDownloadClick: (documentType, scanFormIds, url) => {
      const urlWithDownloadParameter = url.includes('?') ? `${url}&download=1` : `${url}?download=1`;
      DocumentService.downloadFile(urlWithDownloadParameter);
      dispatch(documentDownloadStarted(documentType, scanFormIds.length));
      closePrintModal();
    },
    onPrintClick: (documentType, scanFormIds, printer) => {
      const requestId = GuidService.newGuid();
      const printJob = {
        requestId,
        printer,
        documentType,
        ids: scanFormIds,
      };
      dispatch(printDocumentRequest(printJob));
      closePrintModal();
    },
    changeOutputType: (outputType) => dispatch(changeOutputType(outputType)),
    setPrintDestination: (printDestination) => dispatch(setPrintDestination(printDestination)),
    setRememberPrintSettings: (rememberPrintSettings) => dispatch(setRememberPrintSettings(rememberPrintSettings)),
  };
};

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { scanFormIds } = propsFromState;
  const { onPrintClick } = propsFromDispatch;
  const printEndOfDayForms = (printer, documentType) => {
    onPrintClick(documentType, scanFormIds, printer);
  };
  return {
    ...ownProps,
    ...propsFromState,
    ...propsFromDispatch,
    onPrintClick: printEndOfDayForms,
  };
};

export const EndOfDayPrintModalContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PrintModal);
